import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker as AntdDatePicker } from 'components/antd';
import { DatePickerProps } from 'antd/lib/date-picker/interface';

import styles from './styles.module.scss';

interface Props extends DatePickerProps {}
export class DatePicker extends Component<Props> {
	range(start: number, end: number) {
		const result = [];
		for (let i = start; i < end; i++) {
			result.push(i);
		}
		return result;
	}

	disabledDate(current: any) {
		return (
			current &&
			current <
				moment()
					.add(-1, 'day')
					.endOf('day')
		);
	}

	getCurrentTime = () => {
		const currentDate = moment();
		return {
			currentDate,
			currentDateFormat: currentDate.format('DD-MM-YY'),
			currentHour: Number(currentDate.format('HH')),
			currentMin: Number(currentDate.format('mm')),
			currentWholeHour: currentDate.format('HH:mm'),
		};
	};

	// isSameDay = (current: Moment) => {
	// 	return (
	// 		current.format('DD-MM-YY') ===
	// 		this.getCurrentTime().currentDateFormat
	// 	);
	// };

	// getDisabledHours = (current: Moment) => {
	// 	if (this.isSameDay(current)) {
	// 		return this.range(0, this.getCurrentTime().currentHour);
	// 	}
	// 	return [];
	// };

	// getDisabledMinutes = (current: Moment) => {
	// 	const currentHour = Number(current.format('HH'));
	// 	let minRange: number[] = [];
	// 	if (
	// 		this.isSameDay(current) &&
	// 		currentHour === this.getCurrentTime().currentHour
	// 	) {
	// 		const currentMin = this.getCurrentTime().currentMin;
	// 		let min = currentMin + 15;
	// 		if (min > 59) {
	// 			min = 59;
	// 		}
	// 		minRange = this.range(0, min);
	// 	}
	// 	return minRange;
	// };

	// disabledDateTime = (current: Moment | undefined) => {
	// 	if (!current) {
	// 		return {
	// 			disabledHours: () =>
	// 				this.range(0, this.getCurrentTime().currentHour),
	// 			disabledMinutes: () =>
	// 				this.range(0, this.getCurrentTime().currentHour + 15),
	// 			disabledSeconds: () => [0, 59]
	// 		};
	// 	}
	// 	return {
	// 		disabledHours: () => this.getDisabledHours(current),
	// 		disabledMinutes: () => this.getDisabledMinutes(current),
	// 		disabledSeconds: () => [0, 59]
	// 	};
	// };

	// onChange = (date: moment.Moment | null, dateString: string) => {
	// 	const { onChange } = this.props;
	// 	if (!onChange) {
	// 		return;
	// 	}
	// 	if (date) {
	// 		const { currentWholeHour } = this.getCurrentTime();
	// 		if (currentWholeHour === moment(date).format('HH:mm')) {
	// 			onChange(moment(date).utc(), dateString);
	// 			return;
	// 		}
	// 	}
	// 	if (!date) {
	// 		(onChange as any)(date);
	// 		return;
	// 	}
	// 	onChange(moment(date), dateString);
	// };

	render() {
		return (
			<div id="booking-datepicker" className={styles.datePickerWrap}>
				<AntdDatePicker
					{...this.props}
					// onChange={this.onChange}
					getCalendarContainer={() =>
						document.getElementById(`booking-datepicker`) || document.body
					}
					allowClear={false}
					disabledDate={this.disabledDate}
					suffixIcon={React.createElement('i', { className: styles.datePickerIcon }, '')}
				/>
			</div>
		);
	}
}

export default DatePicker;
